import {push} from 'react-router-redux'
import {ACCOUNT_MANAGER} from '../../endpoints'
import {apiPublic} from '../../api'
import {
  EmailLogin as EmailLoginTypes,
  FacebookLogin as FacebookLoginTypes,
  Recover as RecoverTypes,
  Signup as SignupTypes,
} from './types'
import {User} from '../actions'
import loginComponentActions from '../../sections/login/actions/login'
import signupComponentActions from '../../sections/signup/actions/signup'
import {endpoint as endpointText} from '../../common/text'

export class EmailLogin {

  static setEmail(email) {
    return {
      type: EmailLoginTypes.SET_EMAIL,
      email,
    }
  }

  static setPassword(password) {
    return {
      type: EmailLoginTypes.SET_PASSWORD,
      password,
    }
  }

  static login() {
    return function(dispatch, getState) {

      const state = getState().ui.login.emailLogin

      if (state.email === '' || state.password === '') {
        dispatch(EmailLogin.receiveLogin('Por favor complete los campos'))
        return Promise.resolve(false)
      }

      dispatch({type: EmailLoginTypes.LOGIN_EMAIL})

      const data = new FormData()
      data.append('email', state.email)
      data.append('password', state.password)

      return apiPublic.post(ACCOUNT_MANAGER + '/login', data)
        .then(response => {
          dispatch(EmailLogin.receiveLogin(''))
          const data = response.data.description
          dispatch(User.setFirstTime(
            data.id,
            data.email,
            data.missingProfileInformation,
            data.name,
            data.lastName,
            data.permissions,
            data.token,
            data.profilePicture,
            false,
          ))
          // dispatch(push('/'))
          dispatch(loginComponentActions.close())
          return true
        }, error => {
          let message = ''
          if (error.response) {
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(EmailLogin.receiveLogin(message))
          return false
        })
    }
  }

  static receiveLogin(error) {
    return {
      type: EmailLoginTypes.RECEIVE_EMAIL_LOGIN,
      error,
    }
  }
}

export class FacebookLogin {

  static login(response) {
    return function(dispatch) {

      if (response.status === 'not_authorized') {
        dispatch(FacebookLogin.receiveLogin('No se pudo ingresar'))
        return Promise.resolve(false)
      }

      const accessToken = response.accessToken
      const facebookId = response.id

      dispatch({type: FacebookLoginTypes.FACEBOOK_LOGIN})

      const data = new FormData()
      data.append('access_token', accessToken)
      data.append('facebook_id', facebookId)

      return apiPublic.post(ACCOUNT_MANAGER + '/login/facebook', data)
        .then(response => {
          dispatch(FacebookLogin.receiveLogin(''))
          const data = response.data.description
          dispatch(User.setFirstTime(
            data.id,
            data.email,
            data.missingProfileInformation,
            data.name,
            data.lastName,
            data.permissions,
            data.token,
            data.profilePicture,
            true,
          ))
          dispatch(push('/micatalogo'))
          dispatch(loginComponentActions.close()) //TODO change so that the reducer of the login dialog reacts to the fail action, which does not exist right now
          dispatch(signupComponentActions.close()) //TODO change so that the reducer of the login dialog reacts to the fail action, which does not exist right now
          return true
        }, error => {
          let message = ''
          if (error.response) {
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(FacebookLogin.receiveLogin(message))
          return false
        })
    }
  }

  static receiveLogin(error) {
    return {
      type: FacebookLoginTypes.RECEIVE_FACEBOOK_LOGIN,
      error,
    }
  }
}

export class Signup {

  static setEmail(email) {
    let emailError = ''
    //TODO validate
    return {
      type: SignupTypes.SIGN_UP_SET_EMAIL,
      email,
      emailError,
    }
  }

  static setName(name) {
    let nameError = ''
    //TODO validate
    return {
      type: SignupTypes.SIGN_UP_SET_NAME,
      name,
      nameError,
    }
  }

  static setLastName(lastName) {
    let lastNameError = ''
    //TODO validate
    return {
      type: SignupTypes.SIGN_UP_SET_LAST_NAME,
      lastName,
      lastNameError,
    }
  }

  static setPhone(phone) {
    let phoneError = ''
    return {
      type: SignupTypes.SIGN_UP_PHONE,
      phone,
      phoneError,
    }
  }

  static setPassword(password) {
    let passwordError = ''
    //TODO validate
    return {
      type: SignupTypes.SIGN_UP_SET_PASSWORD,
      password,
      passwordError,
    }
  }

  static signup() {
    return function(dispatch, getState) {

      const state = getState().ui.login.signup

      if (state.phone.length < 14) {
        dispatch(Signup.receiveSignup('Teléfono inválido'))
        return Promise.resolve(false)
      }

      if (state.emailError !== '' || state.passwordError !== '' || state.email === '' || state.password === '' || state.phone === '') {
        dispatch(Signup.receiveSignup('Por favor complete los campos'))
        return Promise.resolve(false)
      }

      dispatch({type: SignupTypes.SIGN_UP})

      const data = new FormData()
      data.append('email', state.email)
      data.append('password', state.password)
      data.append('name', state.name)
      data.append('last_name', state.lastName)
      data.append('phone', state.phone)

      return apiPublic.post(ACCOUNT_MANAGER + '/signup', data)
        .then(response => {
          dispatch(Signup.receiveSignup(''))
          const data = response.data.description
          dispatch(User.setFirstTime(
            data.id,
            data.email,
            data.missingProfileInformation,
            data.name,
            data.lastName,
            data.permissions,
            data.token,
            data.profilePicture,
          ))
          dispatch(signupComponentActions.close())
          dispatch(push('/micatalogo'))
          return true
        }, error => {
          let message = ''
          if (error.response) {
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(Signup.receiveSignup(message))
          return false
        })
    }
  }

  static receiveSignup(error) {
    return {
      type: SignupTypes.RECEIVE_SIGN_UP,
      error,
    }
  }
}

export class Recover {

  static setStep(step) {
    return {
      type: RecoverTypes.SET_STEP,
      step,
    }
  }

  static step1SetEmail(step1Email) {
    let step1EmailError = ''
    //TODO validate
    return {
      type: RecoverTypes.STEP_1_SET_EMAIL,
      step1Email,
      step1EmailError,
    }
  }

  static step1SendCode() {
    return function(dispatch, getState) {

      const state = getState().ui.login.recover

      if (state.step1EmailError !== '' || state.step1Email === '') {
        dispatch(Recover.step1ReceiveCode(''))
        return
      }

      dispatch({type: RecoverTypes.STEP_1_SEND_CODE})

      const data = new FormData()
      data.append('email', state.step1Email)

      apiPublic.post(ACCOUNT_MANAGER + '/recoverPassword', data)
        .then(response => {
          dispatch(Recover.step1ReceiveCode(''))
          dispatch(Recover.step2SetEmail(state.step1Email))
          dispatch(Recover.setStep(1))
        }, error => {
          let message = ''
          if (error.response) {
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(Recover.step1ReceiveCode(message))
        })
    }
  }

  static step1ReceiveCode(step1Error) {
    return {
      type: RecoverTypes.STEP_1_RECEIVE_CODE,
      step1Error,
    }
  }

  static step2SetEmail(step2Email) {
    let step2EmailError = ''
    //TODO validate
    return {
      type: RecoverTypes.STEP_2_SET_EMAIL,
      step2Email,
      step2EmailError,
    }
  }

  static step2SetPassword(step2Password) {
    let step2PasswordError = ''
    //TODO validate
    return {
      type: RecoverTypes.STEP_2_SET_PASSWORD,
      step2Password,
      step2PasswordError,
    }
  }

  static step2SetCode(step2Code) {
    let step2CodeError = ''
    //TODO validate
    return {
      type: RecoverTypes.STEP_2_SET_CODE,
      step2Code,
      step2CodeError,
    }
  }

  static step2SendNewPassword() {
    return function(dispatch, getState) {

      const state = getState().ui.login.recover

      if (state.step2EmailError !== '' || state.step2PasswordError !== '' || state.step2Email === '' || state.step2Password === '') {
        dispatch(Recover.step2ReceiveNewPassword(''))
        return
      }

      dispatch({type: RecoverTypes.STEP_2_SEND_NEW_PASSWORD})

      const data = new FormData()
      data.append('email', state.step2Email)
      data.append('password', state.step2Password)
      data.append('recoveryCode', state.step2Code)

      apiPublic.post(ACCOUNT_MANAGER + '/changePassword', data)
        .then(response => {
          dispatch(Recover.step2ReceiveNewPassword(''))
          dispatch(push('/ingresar'))
        }, error => {
          let message = ''
          if (error.response) {
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(Recover.step2ReceiveNewPassword(message))
        })
    }
  }

  static step2ReceiveNewPassword(step2Error) {
    return {
      type: RecoverTypes.STEP_2_RECEIVE_NEW_PASSWORD,
      step2Error,
    }
  }
}

export class LoginAs {
  static loginAs(token) {
    return dispatch => {
      dispatch(User.logOut())
      apiPublic.post(ACCOUNT_MANAGER + '/login/token', null, {headers: {Authorization: token}})
        .then(response => {
          const data = response.data.description

          console.log(data)

          dispatch(User.setFirstTime(
            data.id,
            data.email,
            data.missingProfileInformation,
            data.name,
            data.lastName,
            data.permissions,
            data.token,
            data.profilePicture,
            false,
          ))
          dispatch(push('/micatalogo'))
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/login/actions.js